var map = {
	"./arrow_down.svg": "9994",
	"./arrow_left_white.svg": "a2c0",
	"./arrow_right_white.svg": "e2f1",
	"./b@3x.png": "517a",
	"./back_icn@2x.png": "b7f1",
	"./background-icn-blue.svg": "9156",
	"./background-icn-darkgray.svg": "a6ff",
	"./bg/border_dotline.png": "43ba",
	"./blk_icn@2x.png": "e8b58",
	"./blur_icn-off.svg": "3760",
	"./blur_icn-on.svg": "665b",
	"./camera_icn-blue.svg": "d2aa",
	"./camera_icn-darkgray.svg": "889c",
	"./camera_icn-gray.png": "8d89",
	"./camera_icn-off@2x.png": "e41b",
	"./camera_icn-on@2x.png": "d09c",
	"./camera_icn_blocked.svg": "a8f2",
	"./chat_icon_sp@2x.png": "9cac",
	"./chat_icon_sp_off@2x.png": "f115",
	"./chat_icon_sp_on@2x.png": "9cf6",
	"./check_blue.svg": "15c9",
	"./check_circle.svg": "3cde",
	"./check_circle_green.svg": "ebc2",
	"./check_gray.svg": "fdb2",
	"./color_palette-blue.svg": "365d",
	"./color_palette-darkgray.svg": "bf75",
	"./color_sp_blk@2x.png": "caf1",
	"./color_sp_wht@2x.png": "7f03",
	"./device_error_sample_image.svg": "0d4f",
	"./download.svg": "9f0f",
	"./download_icn.png": "5a5db",
	"./exit_icn@2x.png": "aa37",
	"./folder_icon.svg": "ff4d",
	"./folder_icon_add.svg": "bfa2",
	"./folder_icon_disabled.svg": "5ceb",
	"./folder_icon_list.svg": "ba2a",
	"./folder_icon_plus.svg": "5de6",
	"./hide_dark.png": "0046",
	"./hide_light.png": "5c03",
	"./i@3x.png": "74d3",
	"./icon/device_error_exclamation.svg": "a912",
	"./icon/next-brand.svg": "d80d",
	"./icon/next.svg": "fc1c",
	"./icon/prev-brand.svg": "db7b",
	"./icon/prev.svg": "95f1",
	"./icon/select-orange.svg": "c32a",
	"./icon/select.svg": "47260",
	"./icon/vote_bad.svg": "ba5a",
	"./icon/vote_bad_active.svg": "fefd",
	"./icon/vote_good.svg": "84b2",
	"./icon/vote_good_active.svg": "8db7",
	"./icon/vote_neutral.svg": "8973",
	"./icon/vote_neutral_active.svg": "b9b9f",
	"./icon/vote_verybad.svg": "5106",
	"./icon/vote_verybad_active.svg": "4172",
	"./icon/vote_verygood.svg": "d892",
	"./icon/vote_verygood_active.svg": "0c8d",
	"./icon_3dots.svg": "98c1",
	"./icon_check.svg": "f0b8",
	"./icon_folder.svg": "e075",
	"./img_teacher_01.svg": "8971",
	"./img_teacher_02.svg": "5222",
	"./info_icon.svg": "6970",
	"./landscape_sp@2x.png": "f19e",
	"./language-blue.svg": "2525",
	"./language-darkgray.svg": "0606",
	"./layout_1_icn@2x.png": "b266",
	"./layout_2_icn@2x.png": "0a61",
	"./layout_3_icn@2x.png": "c8ef",
	"./logo_dark@2x.png": "8369",
	"./logo_light@2x.png": "7385",
	"./logo_myStage-GR.svg": "fe1e",
	"./manual_icon_sp_off@2x.png": "6c3e",
	"./manual_icon_sp_on@2x.png": "7b92",
	"./menu_icon_blue.svg": "624d",
	"./menu_icon_gray.svg": "6f5f",
	"./menu_icon_light.svg": "cda8",
	"./mic_icn-blue.svg": "bfc0",
	"./mic_icn-blue@2x.png": "3b14",
	"./mic_icn-darkgray.svg": "e534",
	"./mic_icn-gray.png": "9ecd",
	"./mic_icn-off@2x.png": "1d57",
	"./mic_icn-on@2x.png": "bac6",
	"./modal_close_icn.svg": "d8a4",
	"./movie_box_sp@2x.png": "56c9",
	"./movie_box_sp_blk@2x.png": "a312",
	"./movie_zoom_dark@2x.png": "4142",
	"./movie_zoom_light@2x.png": "c551",
	"./movie_zoomout_dark@2x.png": "93bb",
	"./movie_zoomout_light@2x.png": "d057",
	"./mystage_logo@2x.png": "8197",
	"./name_bg.png": "44db",
	"./next_icn@2x.png": "27ea",
	"./out_icn@2x.png": "5aee",
	"./pallet@3x.png": "dff5",
	"./pencil_icon.svg": "c6b9",
	"./pulldown_icn@2x.png": "cd68",
	"./pullright_icn@2x.png": "fa85",
	"./question_icon-blue.svg": "86ad",
	"./question_icon-darkgray.svg": "902a",
	"./question_icon_sp@2x.png": "5167",
	"./recording_active.svg": "a9b1",
	"./recording_dark.svg": "a176",
	"./recording_dark_stop.svg": "261c",
	"./recording_disable.svg": "4695",
	"./recording_light.svg": "2956",
	"./recording_light_stop.svg": "f4a8",
	"./refresh_dark@2x.png": "071d",
	"./refresh_light@2x.png": "1f9e",
	"./s@3x.png": "fa13",
	"./scaling_cursor_horizontal.svg": "4629",
	"./scaling_cursor_vertical.svg": "d9ef",
	"./scaling_icon_dark.svg": "3755",
	"./scaling_icon_light.svg": "5c18",
	"./send_icn-active.svg": "3451",
	"./send_icn-disabled.svg": "a923",
	"./send_icn@2x.png": "f5b9",
	"./share_dark@2x.png": "c8af",
	"./share_light@2x.png": "6405",
	"./show_dark.png": "0170",
	"./show_light.png": "aee4",
	"./speaker_icn-blue.svg": "777c",
	"./speaker_icn-darkgray.svg": "1efd",
	"./speaker_icn-gray.png": "7ddb",
	"./speaker_icn.png": "e04c",
	"./speech_bubble.svg": "0446",
	"./text_icon_sp@2x.png": "abf0",
	"./text_zoom_sp@2x.png": "2c64",
	"./text_zoomout_sp@2x.png": "ce8c",
	"./three_dots@2x.png": "8205",
	"./translate_icn.svg": "a1a8",
	"./u@3x.png": "2b801",
	"./up-icon-beginner.svg": "702c",
	"./up-icon-confirmation.svg": "e3ea",
	"./up-icon-level0.svg": "4699",
	"./up-icon-question.svg": "20be",
	"./up-icon-request.svg": "6664",
	"./up-icon-technicalproblem.svg": "cf66",
	"./up-icon-trouble.svg": "48c2",
	"./up_icn@2x.png": "b200",
	"./vocabulary_instruction.png": "1343",
	"./wht_icn@2x.png": "afcd",
	"./zoom_in_dark.png": "4b7f",
	"./zoom_in_dark.svg": "4326",
	"./zoom_in_disabled.svg": "b1cc",
	"./zoom_in_light.svg": "dc6a",
	"./zoom_out_dark.svg": "5538",
	"./zoom_out_disabled.svg": "ddd4",
	"./zoom_out_light.svg": "3e42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";